import BaseApiClient from '../BaseApiClient';

export type SavedFilterSection = 'pipelines' | 'tasks' | 'audiences';

export type SavedFilterCriteria = Record<string, string | number | string[] | null>;

export type SavedFilter = {
  id: number;
  section: SavedFilterSection;
  context_id: number | null;
  name: string;
  criteria: SavedFilterCriteria;
  order: number | null;
  created_at?: string | null;
  updated_at?: string | null;
};

export type SavedFilterPayload = {
  id?: number;
  section: SavedFilterSection;
  context_id?: number | null;
  name: string;
  criteria: SavedFilterCriteria;
  order?: number | null;
};

const API_VERSION = { Version: '2025-11-14' };

export class ApiSavedFilters extends BaseApiClient {
  async list(params: {
    section: SavedFilterSection;
    context_id?: number | null;
  }): Promise<SavedFilter[]> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/saved-filters', {
          headers: API_VERSION,
          params: {
            section: params.section,
            ...(params.context_id != null
              ? { context_id: params.context_id }
              : {})
          }
        })
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err));
    });
  }

  async get(id: number): Promise<SavedFilter> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/saved-filters/${id}`, { headers: API_VERSION })
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err));
    });
  }

  async createOrUpdate(payload: SavedFilterPayload): Promise<SavedFilter> {
    return new Promise((resolve, reject) => {
      this.client
        .put('/saved-filters', payload, { headers: API_VERSION })
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err));
    });
  }

  async delete(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.client
        .delete(`/saved-filters/${id}`, { headers: API_VERSION })
        .then(() => resolve())
        .catch((err) => reject(err));
    });
  }
}
